import { Component, OnDestroy, OnInit } from '@angular/core';
import { finalize, Subject, takeUntil, filter,pipe } from 'rxjs';
import { TeamService } from '../../../_core/services/team.service';
import { ToastService } from '../../../_core/services/toast.service';
import { SeasonSelectorService } from '../../../_shared/components/season-selector/season-selector.service';
import { Season } from '../../../_shared/models/season.model';
import { Team } from '../../../_shared/models/team.model';
import { TeamDetailsService } from '../team-details.service';
import { NavController } from '@ionic/angular';
import { League } from '../../../_shared/models/league.model';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-team-coaches',
  templateUrl: './team-coaches.component.html',
  styleUrls: ['./team-coaches.component.scss'],
  standalone: false
})
export class TeamCoachesComponent implements OnInit, OnDestroy {
  team: Team;
  isLoading = false;
  selectedSeason: Season;

  private readonly destroy$: Subject<void> = new Subject();
  isOwner: boolean;
  isOfficial: boolean;
  teamId: string;

  constructor(
    private seasonSelectorService: SeasonSelectorService,
    private teamService: TeamService,
    private teamDetailsService: TeamDetailsService,
    private toast: ToastService,
    private navCtrl: NavController, 
    private activatedRoute: ActivatedRoute
  ) { }

  async ngOnInit() {
    await this.getRouteSubscription();
    this.selectedSeason = this.seasonSelectorService.season;
    await this.getTeamCoaches();
    await this.subscriptions();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getRouteSubscription() {
    this.activatedRoute.parent?.params
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: async (params) => {
          try {
            const { id } = params;
            this.teamId = id;
          } catch (error) {
            console.error('Error fetching route data:', error);
          } finally {
             this.isLoading = false;
          }
        },
        error: (err) => {
          console.error('Route subscription error:', err);
           this.isLoading = false;
        }
      });
  }

  getTeamCoaches() {
    this.isLoading = true;
    if(this.teamId){
        this.teamDetailsService
          .getTeamCoaches(this.teamId)
          .pipe(
            takeUntil(this.destroy$),
            finalize(() => this.isLoading = false))
          .subscribe({
            next: async (res) => {
                this.team = res.data;
                await this.getTeamOwnerStatus();
            }
        });
    }
  }

  isRole(participant, roleType) {
    return participant.roles.some(role => role === roleType);
  }


  synchronizeRoster() {
    const teamId = this.teamDetailsService.teamInfo._id;
    this.isLoading = true;

    this.teamDetailsService
      .synchronizeTeamRoster(this.team.teamId, this.selectedSeason?.seasonId, this.team?.organisations[0].organisationAbbreviation)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => this.isLoading = false))
      .subscribe({
        next: (res) => {
            this.team = res.data;
            this.toast.presentToast(res.message);
        }
      });
  }

  subscriptions() {
    this.seasonSelectorService
      .subscribeSelectedSeason()
      .pipe(
        takeUntil(this.destroy$),
        filter(value => !!value)
      )
      .subscribe(
        (season: Season) => {
          this.selectedSeason = season;
          this.getTeamCoaches()
        }
      );

    this.teamDetailsService
      .subscribeTeamUpdate()
      .pipe(
        takeUntil(this.destroy$),
      )
      .subscribe(
        (team: Team) => {
          this.team = team;
          this.getTeamCoaches();
          
          this.getTeamOwnerStatus();
        }
      );
  }

  private async getTeamOwnerStatus() {
    this.isOwner = this.teamDetailsService.isOwner(this.team.owners);
    this.isOfficial = await this.teamDetailsService.isOfficial(this.team.officials);
  }

  goToProfilePage(player: any){    
    if(this.team._id) {
        this.navCtrl.navigateRoot(`my-players/${player.person._id}/team/${this.team._id}`);
    } else {
        this.navCtrl.navigateRoot(`my-players/${player.person._id}`);
    }
  }

  getUserSex(user) {
    if (user.biographicalInformation) {
      if (user.biographicalInformation.sex === 'M') return 'Male';
      else return 'Female';
    }
  }
}
